import React from 'react'
import LimitedViewText from './LimitedViewText'

import bgHeader from 'images/carousel-2.jpg'
import pdfLogo from 'images/pdf-logo.png'

export default function Information2({ limitedView, regenerated, industry }) {
  const commonText = {
    title: 'Content Strategy',
    listLeftTitle: 'You should:',
    listRightTitle: 'You should not:',
  };

  const texts = regenerated ? {
    listLeftText1: 'Remember to keep creating affordable and snack-able. The more the better.',
    listLeftText2: 'Your audience will give you a very limited amount of their time, keep serving them short and clear messages \n.',
    listLeftText3: <CategoryText industry={industry}/>,
    listLeftText4: 'Content will always be your key asset to get their attention and fight ad blockers, so go through the report and find your right to win.',
    listLeftText5: 'Develop the perfect content pillar strategy (next slide) and follow it every week .',
    listRightText1: 'Immediately jump on any topic of conversation they talk about, instead find something relevant to them and in which you can play a role or have something to say.',
    ...commonText
  } : {
    listLeftText1: 'We live in an age of personalization. One piece of content will not work for all your audiences.',
    listLeftText2: 'Create several pieces of snack-able content and use these to test which ones get better reactions.',
    listLeftText3: <CategoryText industry={industry}/>,
    listLeftText4: 'Content is key to getting their attention and fight ad blockers, so go through the report and find your right to win.',
    listLeftText5: 'Develop the perfect content pillar strategy (next slide) and follow it every week .',
    listRightText1: 'Immediately jump on any topic of conversation they talk about, instead find something relevant to them and in which you can play a role or have something to say.',
    ...commonText
  };

  return (
    <section className="section md-pt4 sm-p0" data-anchor="information-2">
      <div className="slider-box slider-box--pdf-p0 bg-white box-shadow-box p4 x-lg-p3">
        <div>
          <div className="flex mb2 pt3 sm-p0">
            <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
            <div className="bg-violet-red mr2 rounded-6" style={{ height: 20, width: 20 }} />
            <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
            <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
          </div>

          <h2 className="persona-sub-title mb4 sm-mb3">{texts.title}</h2>

          <div className="flex flex-wrap mxn2">
            <div className="col-6 px2 sm-col-12 sm-mb3">
              <div className="border border-violet-red box-shadow-around bw-2 col-12 overflow-hidden rounded-16">
                <div className="border-top border-violet-red bw-10 p3">
                  {limitedView ?
                    <LimitedViewText />
                    : <>
                      <p className="flex flex-center h3 mb3">
                        <i className="fa fa-check-circle fs-36 mr2 text-violet-red" />
                        {texts.listLeftTitle}
                      </p>

                      <ul className="list-square pl-20 text-violet-red">
                        <li className="mb2"><span className="text-black">{texts.listLeftText1}</span></li>
                        <li className="mb2"><span className="text-black">{texts.listLeftText2}</span></li>
                        <li className="mb2"><span className="text-black">{texts.listLeftText3}</span></li>
                        <li className="mb2"><span className="text-black">{texts.listLeftText4}</span></li>
                      </ul>
                    </>
                  }
                </div>
              </div>
            </div>

            <div className="col-6 flex px2 sm-col-12">
              <div className="border border-iron box-shadow-around bw-2 col-12 overflow-hidden rounded-16">
                <div className="p3">
                  {limitedView ?
                    <LimitedViewText />
                    : <>
                      <p className="flex flex-center h3 mb3">
                        <i className="fa fa-times-circle fs-36 mr2 text-iron" />
                        {texts.listRightTitle}
                      </p>

                      <ul className="list-square pl-20 text-iron">
                        <li className="mb2"><span className="text-black">{texts.listRightText1}</span></li>
                      </ul>
                    </>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

function CategoryText({ industry }) {
  switch(industry.value) {
    case 2000364331:
      return 'The Automotive category is all about image and the relationship people have with their cars. Use it.'
    case 2000366930:
      return 'The beauty industry has changed as of 2020. The zoom boom made it more important to have a healthy skin and made it Ok to be sen without make up.'
    case 2000364332:
      return 'Electronics is all about the latest and the coolest. But not everyone understand the jargon. Keep it simple and to the point.'
    case 2000376164:
      return 'Fashion is all about image and self expression. Let your audience know what it means to wear your brands.'
    case 2000376298:
      return 'In FMCG remember the your buyer might not be your user. Think of both these audiences separately.'
    case 2000349636:
      return 'Fitness related products are about lifestyle and people wanting to feel better about themselves, so be aspirational.'
    case 2000362567:
      return 'Pet owner treat their pets as family. Never underestimate the emotional connection they have with their pets. Use it.'
    case 2000376228:
      return 'The travel industry has forever changed. But the need to discover is still present and so think of how you can satisfy your audiences needs and desires.'
  }
}